/**
 * KeyValue Component
 *
 * A reusable component for displaying label-value pairs in a consistent format.
 * Supports both inline and block display modes.
 */

import { Box, Typography } from "@mui/material"
import Stack from "src/shared/components/stack"
import { KeyValueProps } from "../types"

/**
 * KeyValue component for displaying label-value pairs
 * @param label - The label text to display
 * @param value - The value to display (string or number)
 * @param inline - Whether to display inline (horizontal) or block (vertical)
 */
export default function KeyValue({ label, value, inline = false }: KeyValueProps) {
  if (inline) {
    return (
      <Stack variant="rowCenter" gap={1}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}:
        </Typography>
        <Typography variant="body2" fontWeight={500}>
          {String(value)}
        </Typography>
      </Stack>
    )
  }

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        {String(value)}
      </Typography>
    </Box>
  )
}
